<div class="asset-type-rate-component">
  @if (title) {
    <div class="row">
      <div class="col-12">
        <div class="mat-h3 rate-card-section-title">{{title}}</div>
      </div>
    </div>
  }
  @for (formGroup of formArray.controls; track formGroup) {
    <div class="row">
      <div class="col-lg-6 col-md-12">
        <mat-form-field>
          <mat-label>Asset Type</mat-label>
          <mat-select [formControl]="formGroupControl(formGroup, 'type')" required>
            @for (catAndType of catAndTypes; track catAndType) {
              <mat-option [value]="catAndType">
                {{catAndType.typeValue}}
              </mat-option>
            }
          </mat-select>
          @for (errorKey of errorKeys(formGroupControl(formGroup, 'type')); track errorKey) {
            <mat-error>
              @if (formGroupControl(formGroup, 'type').touched && formGroupControl(formGroup, 'type').hasError(errorKey)) {
                {{errorMessage(formGroupControl(formGroup, 'type'), errorKey)}}
              }
            </mat-error>
          }
        </mat-form-field>
      </div>
      <div class="col-lg-3 col-md-12">
        <mat-form-field>
          <input matInput [inputMask]="createTwoDecimalInputMask" type="text" [formControl]="formGroupControl(formGroup, 'rate')">
          <span class="mdi mdi-percent" matSuffix></span>
        </mat-form-field>
      </div>
      <div class="col-lg-1 col-md-12 mt-3">
        <span class="mdi mdi-close" matTooltip="Delete entry" (click)="onRemove($event)"></span>
      </div>
    </div>
  }
  <div class="row">
    <div class="col-12"
      fxLayout="row"
      fxLayout.lt-md="column"
      fxLayoutGap="10px">
      <button mat-stroked-button (click)="onAdd($event)" class="mat-flat-button-custom">
        <span class="mdi mdi-plus"></span>
        Add
      </button>
    </div>
  </div>
</div>
